import React from 'react';

import './style.scss';

const FreightRestrictions = () => (
  <div className="text-center freight-restrictions">
    <h3>Passenger Boat Freight Restrictions</h3>
    <p>Please plan accordingly.</p>
    {/* <p>
      <i className="far fa-exclamation-circle" /> <strong>Peak trips</strong>{' '}
      marked in <strong>bold type</strong> on the schedules indicate trips where
      additonal baggage may be refused at anytime due to space limitations.
    </p> */}
    {/* <p>
      <i className="far fa-exclamation-circle" /> Due to the need to social
      distance, and the requirement to reduce cargo aboard our passenger
      vessels, all non-essential items MUST now be shipped on the freight boat.{" "}
      <strong>Regardless of Load Conditions!</strong>
    </p>
    <p>
      <i className="far fa-exclamation-circle" /> Essential items are personal
      effects & perishables.
    </p>
    <hr /> */}
    <p>
      <i className="far fa-check-circle" /> Each passenger will be limited to{' '}
      <strong>One Trip Through The Gate</strong> with two bags (25lbs max) which
      must fit under your seat. <strong>Free of charge.</strong>
    </p>
    <p>
      <i className="far fa-check-circle" /> All other essential items,{' '}
      <strong>when accepted</strong>, must be carried in the freight area on the
      ferry, and will be charged for accordingly.{' '}
      <strong>$2 minimum per item.</strong>
    </p>
    <hr />
    <h5>
      <i className="far fa-exclamation-circle" /> No Large Coolers (50lbs Max)
    </h5>
    <p>
      <i className="far fa-check-circle" /> Coolers 48qt. and smaller will be
      permitted. <strong>$4 minimum per item.</strong>
    </p>
    <hr />
    <h5>
      <i className="far fa-exclamation-circle" /> No Large Wagons or Large Carts (50lbs Max)
    </h5>
    <p>
      <i className="far fa-check-circle" /> Wire carts will be permitted.{' '}
      <strong>$7</strong>
    </p>
    <p>
      <i className="far fa-check-circle" /> Folding wagons will be permitted.{' '}
      <strong>$14</strong>
    </p>
    <p>
      <i className="far fa-check-circle" /> Radio Flyer style wagons will be
      permitted. <strong>$14</strong>.
    </p>
    <p>
      <i className="far fa-exclamation-circle" />{' '}
      <strong>These carts should only contain essential items.</strong>
    </p>
    <hr />
    <p>
      <i className="far fa-exclamation-circle" /> <strong>No</strong> bulk
      groceries, beverages, or furniture of any kind.
    </p>
    <p>
      <i className="far fa-exclamation-circle" /> <strong>No</strong> plants,
      landscaping, or building materials of any kind.
    </p>
    <p className="text-large">
      <i className="far fa-exclamation-circle" /> <strong>No</strong> bikes of
      any size permitted at anytime.
    </p>
    {/* <p>
      <i className='far fa-exclamation-circle' /> No bikes, large wagons or
      large carts anytime.
    </p> */}
    {/* <p>
      <i className='far fa-exclamation-circle' /> We urge you to plan ahead and
      ship items on the freight boat which leaves Bay Shore for all beaches at
      10:00am Monday through Friday with an additional boat on Saturdays during
      peak season. Please check the Fire Island Freight website for Saturday
      freight boat availability.
    </p> */}
    {/* <p>
      <i className='far fa-suitcase-rolling' /> Each passenger is permitted one
      piece of baggage totalling 25lbs free of charge. This{' '}
      <strong>must</strong> fit under your seat.
    </p> */}
    {/* <p>
      <i className='far fa-exclamation-circle' /> All carts and wagons (when
      permitted) must be stowed in the designated freight area, <br />
      and will be charged a <strong>minimum</strong> of <strong>$6</strong>
    </p> */}
    {/* <p>
      <i className='far fa-exclamation-circle' /> All additional baggage,
      coolers, etc. (when permitted) will be charged for accordingly.
    </p> */}
    <div className="notice notice-important notice-small">
      <i className="fas fa-fire" /> No flammables or compressed gas containers
      (new or used) permitted on passenger boats.
    </div>
  </div>
);

export default FreightRestrictions;
